import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { UserAdminReport } from '@/module/AnnualReport/perRole/UserAdminReport';

import { NoContentPlaceholder } from '@/core/components';

import { HierarchyDisciplineSelect } from '@feature/utils';
import { useDisciplineAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';
import { ValidationStatus } from '@feature/validation';

export interface DisciplineAdminReportProps {
  year: number;
  validationStatus: ValidationStatus | null;
  filterAfterAffiliation: boolean;
}

export function DisciplineAdminReport({ year, validationStatus, filterAfterAffiliation }: DisciplineAdminReportProps) {
  const { userId, selectProps } = useDisciplineAdminHierarchy();
  const { t } = useTranslation();
  return (
    <Stack>
      <HierarchyDisciplineSelect {...selectProps} />
      {userId == null && <NoContentPlaceholder title={t('hierarchySelectValidation.fromDisciplines')} />}
      {userId != null && (
        <UserAdminReport
          userId={userId}
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
    </Stack>
  );
}
